export const INTERNAL_DATE_FORMAT = 'YYYY-MM-DD';
export const UI_DATE_FORMAT = 'DD.MM.YYYY';
export const UI_SHORT_DATE_FORMAT = 'DD.MM.YY';

export const COLORS = {
  WARNING: 'warning',
  SUCCESS: 'success',
  DANGER: 'danger',
  SECONDARY: 'secondary',
  PRIMARY: 'primary',
  LIGHT: 'light',
  INFO: 'info',
  LINK: 'link',
};
